/* MAROCK — enhancements for the Releasit COD form.
   Releasit renders plain DOM with rsi-* classes and may re-render at any time,
   so everything here is idempotent and re-applied from a MutationObserver.
   Nothing here submits or changes the order: the city dropdown only writes
   into Releasit's own city input, which Releasit then sends as usual. */
(function () {
  'use strict';

  var CUTOFF_HOUR = 17; // same cut-off the old delivery widget used
  var CITIES = ['Casablanca','Rabat','Salé','Témara','Mohammedia','Marrakech','Tanger','Fès','Meknès','Agadir','Kénitra','Oujda','Tétouan','El Jadida','Safi','Béni Mellal','Nador','Khouribga','Settat','Berrechid','Bouskoura','Dar Bouazza','Skhirat','Bouznika','Laâyoune','Dakhla','Errachidia','Ouarzazate','Taza','Larache','Ksar El Kébir','Guelmim','Khémisset','Essaouira','Al Hoceïma','Taroudant','Tiznit','Ifrane','Azrou','Berkane','Sidi Kacem','Sidi Slimane','Youssoufia','Fquih Ben Salah'].sort(function (a, b) { return a.localeCompare(b, 'fr', { sensitivity: 'base' }); }); // A→Z, "Autre ville" stays last
  var OTHER = 'Autre ville';
  var DRAWER_BTN = 'Commander · paiement à la livraison';
  var LABELS = { 'Subtotal': 'Sous-total', 'Shipping': 'Livraison', 'Discounts': 'Réduction', 'Discount': 'Réduction', 'Total': 'Total' };
  var RULES = {
    first_name: function (v) { return v.trim().length >= 3; },
    phone: function (v) { return /^0?[5-7]\d{8}$/.test(v.replace(/\D/g, '').replace(/^212/, '')); },
    city: function (v) { return v.trim().length >= 2; },
    address: function (v) { return v.trim().length >= 5; }
  };
  var SVG = {
    truck: '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="#35673F" stroke-width="2"><path d="M3 7h11v9H3zM14 10h4l3 3v3h-7"/><circle cx="7" cy="17.5" r="1.6"/><circle cx="17" cy="17.5" r="1.6"/></svg>',
    eye: '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="#35673F" stroke-width="2"><circle cx="11" cy="11" r="6"/><path d="M20 20l-4.5-4.5"/></svg>',
    swap: '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="#35673F" stroke-width="2"><path d="M4 9h13l-3-3M20 15H7l3 3"/></svg>',
    check: '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>'
  };

  /* Releasit's form container. On desktop it is #_rsi-form-container-embedded, but on some phones
     Releasit mounts the form in another container, so find it from the form itself and tag it
     with .mk-rsi — all MAROCK styles are scoped to that class. */
  function root() {
    var c = document.getElementById('_rsi-form-container-embedded');
    if (!c) {
      var f = document.querySelector('._rsi_main_form_element');
      if (!f) return null;
      var w = f.closest('[class*="rsi-form-wrapper"]') || f;
      c = f.closest('[id^="_rsi-form-container"]') || (w.parentElement && w.parentElement !== document.body ? w.parentElement : w);
    }
    if (!c.classList.contains('mk-rsi')) c.classList.add('mk-rsi');
    return c;
  }

  /* ---------- time in Casablanca ---------- */
  // Morocco's legal time is UTC+1. Browser tz databases disagree about Africa/Casablanca,
  // so use the fixed offset (matches the old delivery widget's countdown and dates).
  var MA_OFFSET_MIN = 60;
  function casaParts(d) {
    var t = new Date(d.getTime() + MA_OFFSET_MIN * 60000);
    return { y: t.getUTCFullYear(), m: t.getUTCMonth() + 1, d: t.getUTCDate(), h: t.getUTCHours(), mi: t.getUTCMinutes() };
  }
  function fmtDate(y, m, d) {
    var dt = new Date(Date.UTC(y, m - 1, d));
    return String(dt.getUTCDate()).padStart(2, '0') + '/' + String(dt.getUTCMonth() + 1).padStart(2, '0') + '/' + dt.getUTCFullYear();
  }
  function plusDays(y, m, d, n) { var dt = new Date(Date.UTC(y, m - 1, d + n)); return [dt.getUTCFullYear(), dt.getUTCMonth() + 1, dt.getUTCDate()]; }
  function etaHTML() {
    var n = casaParts(new Date());
    var mins = n.h * 60 + n.mi, cut = CUTOFF_HOUR * 60;
    var cutDay = mins < cut ? [n.y, n.m, n.d] : plusDays(n.y, n.m, n.d, 1);
    var left = mins < cut ? cut - mins : 24 * 60 - mins + cut;
    var a = plusDays(cutDay[0], cutDay[1], cutDay[2], 1), b = plusDays(cutDay[0], cutDay[1], cutDay[2], 4);
    return '🕚 Commandez dans les <span class="mk-cd">' + Math.floor(left / 60) + ' h ' + String(left % 60).padStart(2, '0') + ' min</span> et recevez votre colis entre le <b>' +
      fmtDate(a[0], a[1], a[2]) + '</b> et le <b>' + fmtDate(b[0], b[1], b[2]) + '</b>.';
  }

  /* ---------- helpers ---------- */
  var nativeSet = Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, 'value').set;
  function setReactValue(input, v) {
    nativeSet.call(input, v);
    input.dispatchEvent(new Event('input', { bubbles: true }));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }
  function money(el) { var m = (el && el.textContent || '').replace(/\s/g, '').match(/(\d+(?:[.,]\d+)?)/); return m ? Math.round(parseFloat(m[1].replace(',', '.'))) : 0; }

  /* ---------- pieces ---------- */
  var ERRORS = [
    [/^This field is required\.?$/i, 'Ce champ est obligatoire.'],
    [/phone/i, 'Numéro marocain de 10 chiffres, ex : 06 12 34 56 78.'],
    [/too short|at least|minimum/i, 'Trop court, merci de compléter.'],
    [/invalid|not valid/i, 'Valeur non valide, merci de vérifier.']
  ];
  function translateErrors(r) {
    r.querySelectorAll('.rsi-text-input-error-row, .rsi-checkbox-error-row').forEach(function (el) {
      var t = el.textContent.trim();
      if (!t || /[àâçéèêëîïôûù]|Ce champ|Numéro|Trop court|Valeur/.test(t)) return;
      for (var i = 0; i < ERRORS.length; i++) {
        if (ERRORS[i][0].test(t)) { el.textContent = ERRORS[i][1]; return; }
      }
    });
  }

  function translateSummary(r) {
    r.querySelectorAll('.rsi-total-summary-label, .rsi-total-summary-total-label').forEach(function (el) {
      var t = el.textContent.trim();
      if (LABELS[t] && t !== LABELS[t]) el.textContent = LABELS[t];
    });
  }

  function discountAmount(r) {
    var amt = 0;
    r.querySelectorAll('.rsi-total-summary-line-item').forEach(function (li) {
      var lab = li.querySelector('.rsi-total-summary-label');
      if (lab && /R[ée]duction|Discount/i.test(lab.textContent)) {
        li.classList.add('mk-disc-line');
        amt = money(li.querySelector('.rsi-total-summary-value'));
      }
    });
    return amt;
  }

  /* Discount-code field (repeat-customer codes). Codes are set in Shopify to not
     combine with the automatic ROCK20, so one replaces the other. */
  function discountUI(r) {
    var w = r.querySelector('.rsi-discounts-wrapper');
    if (!w) return;
    var inp = w.querySelector('input');
    if (inp && inp.placeholder !== 'Code de réduction') inp.placeholder = 'Code de réduction';
    w.querySelectorAll('.rsi-discounts-item-text').forEach(function (el) {
      if (/remise automatique|automatic discount/i.test(el.textContent)) el.textContent = 'ROCK20';
    });
    if (!w.querySelector('.mk-disc-note')) {
      var n = document.createElement('div');
      n.className = 'mk-disc-note';
      n.textContent = 'Client fidèle ? Entrez le code reçu. Un seul code par commande, non cumulable avec la réduction de 20 DH.';
      w.appendChild(n);
    }
  }

  function customTexts(r) {
    var disc = discountAmount(r);
    r.querySelectorAll('.rsi-custom-text').forEach(function (el) {
      var t = el.getAttribute('data-mk') || '';
      var txt = el.textContent;
      if (!t) {
        if (/Rien à payer/.test(txt)) t = 'sub';
        else if (/ROCK20/.test(txt)) t = 'applied';
        else if (/Livraison gratuite en/.test(txt)) t = 'eta';
        else if (/Vérifiez avant de payer/.test(txt)) t = 'trust';
        if (t) el.setAttribute('data-mk', t);
      }
      if (t === 'sub') el.classList.add('mk-sub');
      if (t === 'applied') {
        el.classList.add('mk-applied');
        // honest: only claim ROCK20 when the 20 DH order discount is what Shopify applied
        var html = disc <= 0 ? '' :
          disc === 20 ? SVG.check + '<span>Le code <b>ROCK20</b> a été appliqué à votre commande : vous économisez 20 DH.</span>' :
          SVG.check + '<span>Réduction appliquée à votre commande : vous économisez <b>' + disc + ' DH</b>.</span>';
        if (el.getAttribute('data-mk-html') !== html) { el.innerHTML = html; el.setAttribute('data-mk-html', html); }
        el.style.display = disc > 0 ? '' : 'none';
      }
      if (t === 'eta') {
        el.classList.add('mk-eta');
        var e = etaHTML();
        if (el.getAttribute('data-mk-html') !== e) { el.innerHTML = e; el.setAttribute('data-mk-html', e); }
      }
      if (t === 'trust' && !el.querySelector('.mk-t')) {
        el.classList.add('mk-trust');
        el.innerHTML = '<div class="mk-t">' + SVG.truck + 'Livraison gratuite</div><div class="mk-t">' + SVG.eye + 'Vérifiez avant de payer</div><div class="mk-t">' + SVG.swap + 'Échange de taille gratuit</div>';
      }
    });
  }

  function citySelect(r) {
    var input = r.querySelector('input#city, input[name="city"]');
    if (!input) return;
    var row = input.closest('.rsi-text-input-row');
    if (!row || row.querySelector('.mk-city-select')) return;
    var sel = document.createElement('select');
    sel.className = 'mk-city-select';
    sel.setAttribute('aria-label', 'Ville');
    sel.innerHTML = '<option value="">Choisissez votre ville</option>' +
      CITIES.map(function (c) { return '<option>' + c + '</option>'; }).join('') + '<option>' + OTHER + '</option>';
    var cur = input.value.trim();
    if (cur) sel.value = CITIES.indexOf(cur) >= 0 ? cur : OTHER;
    input.classList.add('mk-city-hidden');
    if (sel.value === OTHER) { input.classList.remove('mk-city-hidden'); row.classList.add('mk-city-other'); }
    input.parentNode.insertBefore(sel, input);
    sel.addEventListener('change', function () {
      if (sel.value === OTHER) {
        row.classList.add('mk-city-other');
        input.classList.remove('mk-city-hidden');
        setReactValue(input, '');
        input.placeholder = 'Tapez votre ville';
        input.focus();
      } else {
        row.classList.remove('mk-city-other');
        input.classList.add('mk-city-hidden');
        setReactValue(input, sel.value);
      }
      progress(r);
    });
  }

  function ticksAndProgress(r) {
    var first = r.querySelector('.rsi-text-input-wrapper');
    if (first && !r.querySelector('.mk-prog-wrap')) {
      var w = document.createElement('div');
      w.className = 'mk-prog-wrap';
      w.innerHTML = '<div class="mk-prog" aria-hidden="true"><i></i></div><div class="mk-progtxt">Plus que 4 infos</div>';
      first.parentNode.insertBefore(w, first);
    }
    Object.keys(RULES).forEach(function (id) {
      var inp = r.querySelector('input#' + id);
      if (!inp) return;
      var row = inp.closest('.rsi-text-input-row');
      if (row && !row.querySelector('.mk-tick')) row.insertAdjacentHTML('beforeend', '<span class="mk-tick" aria-hidden="true">✓</span>');
      if (!inp.getAttribute('data-mk-l')) {
        inp.setAttribute('data-mk-l', '1');
        inp.addEventListener('input', function () { progress(r); });
        inp.addEventListener('change', function () { progress(r); });
      }
    });
    progress(r);
  }

  function progress(r) {
    var done = 0, total = 0;
    Object.keys(RULES).forEach(function (id) {
      var inp = r.querySelector('input#' + id);
      if (!inp) return;
      total++;
      var ok = RULES[id](inp.value || '');
      if (ok) done++;
      var row = inp.closest('.rsi-text-input-row');
      if (row) row.classList.toggle('mk-ok', ok);
    });
    var bar = r.querySelector('.mk-prog i'), txt = r.querySelector('.mk-progtxt');
    if (!bar || !total) return;
    var w = (done / total * 100) + '%';
    if (bar.style.width !== w) bar.style.width = w;
    var left = total - done;
    var s = left === 0 ? "C'est bon, il ne reste qu'à commander" : 'Plus que ' + left + ' info' + (left > 1 ? 's' : '');
    if (txt.textContent !== s) txt.textContent = s; // only write on change, so the observer doesn't loop
  }

  /* ---------- run ---------- */
  /* Shopify's default filter labels come out in English (Search & Discovery isn't installed) */
  var PAGE_FR = { 'Availability': 'Disponibilité', 'Price': 'Prix', 'In stock': 'En stock', 'Out of stock': 'En rupture de stock',
    'Search': 'Rechercher', 'Clear all': 'Tout effacer', 'Remove all': 'Tout effacer', 'Apply': 'Appliquer', 'Filter': 'Filtrer', 'Filters': 'Filtres' };
  function translatePage() {
    var scope = document.querySelectorAll('.facets, facets-form-component, [class*="facets"], [class*="filter"], .search-page-input, form[action*="/search"]');
    for (var s = 0; s < scope.length; s++) {
      var w = document.createTreeWalker(scope[s], NodeFilter.SHOW_TEXT, null), n;
      while ((n = w.nextNode())) {
        var t = n.nodeValue.trim();
        if (t && PAGE_FR[t]) n.nodeValue = n.nodeValue.replace(t, PAGE_FR[t]);
      }
      scope[s].querySelectorAll('[aria-label],[placeholder]').forEach(function (el) {
        ['aria-label', 'placeholder'].forEach(function (a) { var v = el.getAttribute(a); if (v && PAGE_FR[v.trim()]) el.setAttribute(a, PAGE_FR[v.trim()]); });
      });
    }
  }

  var busy = false;
  /* COD only: once the Releasit form is on the page, Shopify's own checkout
     buttons are hidden (CSS under html.mk-cod-only) and any click/submit that
     would open Shopify checkout goes to the COD form instead. If Releasit
     fails to load, the class is never set and normal checkout stays available. */
  var CHECKOUT_SEL = '#checkout, [name="checkout"], a[href*="/checkout"], .shopify-payment-button, shopify-accelerated-checkout, shopify-accelerated-checkout-cart, .cart__dynamic-checkout-buttons';
  function toCodForm(ev) {
    if (!document.documentElement.classList.contains('mk-cod-only')) return;
    var t = ev.type === 'submit' ? (ev.submitter || null) : ev.target;
    var hit = t && t.closest && t.closest(CHECKOUT_SEL);
    if (!hit && ev.type === 'submit' && ev.target && ev.target.action && /\/checkout/.test(ev.target.action)) hit = ev.target;
    if (!hit || (hit.closest && hit.closest('[id^="_rsi-"], [class*="rsi-"]'))) return;
    ev.preventDefault(); ev.stopImmediatePropagation();
    // cart drawer: the COD form for the whole cart lives on the cart page
    if (hit.closest && hit.closest('cart-drawer-component, .cart-drawer')) { location.href = '/cart#commander'; return; }
    var f = root();
    if (f) f.scrollIntoView({ behavior: 'smooth', block: 'start' }); else location.href = '/cart';
  }
  document.addEventListener('click', toCodForm, true);

  /* "Opening the cart" = the cart page with the COD form, never the side drawer.
     Only once Releasit is on the page (mk-cod-only), so the drawer still works if Releasit fails. */
  function codOnly() { return document.documentElement.classList.contains('mk-cod-only') || !!window._RSI_COD_FORM_SETTINGS; }
  function goCart() { if (location.pathname !== '/cart') location.href = '/cart#commander'; }
  document.addEventListener('click', function (ev) {
    if (!codOnly()) return;
    var t = ev.target && ev.target.closest && ev.target.closest('cart-icon, a[href="/cart"], a[href$="/cart"], .header-actions__cart-icon');
    if (!t) return;
    ev.preventDefault(); ev.stopImmediatePropagation();
    goCart();
  }, true);
  new MutationObserver(function (muts) {
    if (!codOnly()) return;
    for (var i = 0; i < muts.length; i++) {
      var n = muts[i].target;
      if (n.hasAttribute && n.hasAttribute('open') && n.closest && n.closest('cart-drawer-component, .cart-drawer')) { goCart(); return; }
    }
  }).observe(document.documentElement, { attributes: true, attributeFilter: ['open'], subtree: true });
  document.addEventListener('submit', toCodForm, true);

  /* On the cart page Releasit attaches its form to the first product form it
     finds — a quick-add card in "Vous aimerez aussi" — instead of the cart.
     Move the container into the cart summary, under the (hidden) checkout button. */
  function placeForm() {
    var c = root();
    if (!c) return;
    var page = document.querySelector('.cart-page');
    var summary = page && page.querySelector('.cart-summary__inner');
    if (summary) {
      if (!page.classList.contains('mk-cart-cod')) page.classList.add('mk-cart-cod');
      if (summary.contains(c)) return;
      var ctas = summary.querySelector('.cart__ctas');
      if (ctas) ctas.after(c); else summary.appendChild(c);
      c.classList.add('mk-in-cart');
      if (location.hash === '#commander') setTimeout(function () { c.scrollIntoView({ behavior: 'smooth', block: 'start' }); }, 300);
    }
  }

  function apply() {
    if (busy) return;
    try { translatePage(); } catch (e) {}
    try { placeForm(); } catch (e) {}
    var r = root();
    if (r) document.documentElement.classList.add('mk-cod-only');
    if (r) document.querySelectorAll('cart-drawer-component #checkout .button-text, .cart-drawer #checkout .button-text').forEach(function (t) {
      if (t.textContent.trim() !== DRAWER_BTN) t.textContent = DRAWER_BTN;
    });
    if (!r) return;
    busy = true;
    try { translateSummary(r); translateErrors(r); customTexts(r); discountUI(r); citySelect(r); ticksAndProgress(r); } catch (e) { /* never break Releasit */ }
    busy = false;
  }
  var t;
  function schedule() { clearTimeout(t); t = setTimeout(apply, 60); }
  function start() {
    apply();
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var n = muts[i].target;
        if (n.nodeType === 1 && n.closest && n.closest('.mk-prog-wrap, .mk-tick')) continue;
        schedule(); return;
      }
    }).observe(document.body, { childList: true, subtree: true, characterData: true });
    setInterval(apply, 30000); // keeps the countdown current
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
